module.exports = __webpack_public_path__ + "static/media/sword-laser-alt.a2cae6a8.svg";